import { render, staticRenderFns } from "./Slack.vue?vue&type=template&id=d5cfd0d2&scoped=true&"
import script from "./Slack.vue?vue&type=script&lang=js&"
export * from "./Slack.vue?vue&type=script&lang=js&"
import style0 from "./Slack.vue?vue&type=style&index=0&id=d5cfd0d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cfd0d2",
  null
  
)

export default component.exports